import React, { Component } from 'react';
import yaml from 'js-yaml';
import { buildPath } from '../utils/route_utils.js'
import Fade from 'react-reveal/Fade';
import '../css/NavbarMenu.css';

class NavbarMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_lang: this.props.lang,
      mobile_flag: false,
      menu_name: this.props.menu_name,
      custom_btn: [{
            title: {
                en: "More custom AI robot & automation solutions",
                zh: "更多客製化 AI 機器人與自動化方案",
                ja: "カスタムAIロボット＆自動化ソリューション"
            },
            route: "/solutions"
        }],
      section: [],
      item: []
    }

    this.open_nav = this.open_nav.bind(this)
    this.get_data = this.get_data.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.current_lang) {
      this.setState({ current_lang: nextProps.lang });
    }
    if (nextProps.menu_name !== this.state.menu_name) {
      this.setState({ menu_name: nextProps.menu_name }, () => this.get_data());
    }
  }

  componentDidMount() {
    this.get_data()
  }

  get_data() {
    fetch(process.env.PUBLIC_URL + '/yaml/section_product.yaml')
    .then(response => response.text())
    .then(text => {
      const parsed = yaml.load(text)["products"];
      this.setState({ section: parsed.section, item: parsed.item });
    });
  }

  navigate(route) {
    window.location.href = buildPath(this.state.current_lang, route);
  }

  open_nav() {
    this.setState({
      mobile_flag: !this.state.mobile_flag
    })
  }

  render() {
        const lang = this.state.current_lang;
        return (
          <>
            <Fade duration="500" delay="200">
                <div className={"v2_nav_menu_section "+lang}>
                    <button className="v2_nav_menu_close" onClick={() => this.props.close_nav()}>&times;</button>

                    <div className="v2_nav_menu_grid">
                        {this.state.item.map((section, idx) => {
                            const filtered = section.filter(p => p.product_status.status !== 2);
                            if (filtered.length === 0) return null;
                            return (
                            <div key={idx} className="v2_nav_menu_group">
                                <h3 className="v2_nav_menu_group_title">{this.state.section[idx][lang]}</h3>
                                <div className="v2_nav_menu_items">
                                    {filtered.map((product, pidx) => (
                                        <button key={pidx} className="v2_nav_menu_card" onClick={() => this.navigate('/tech/' + product.href_link.id)}>
                                            <div className="v2_nav_menu_card_img">
                                                <img src={product.product_img} alt={product.product_title[lang]} />
                                            </div>
                                            <div className="v2_nav_menu_card_info">
                                                {product.product_status[lang] !== "-" &&
                                                    <span className="v2_nav_menu_badge">{product.product_status[lang]}</span>
                                                }
                                                <span className="v2_nav_menu_card_name">{product.product_title[lang]}</span>
                                            </div>
                                        </button>
                                    ))}
                                </div>
                            </div>
                            );
                        })}
                    </div>

                    <div className="v2_nav_menu_footer">
                        {this.state.custom_btn.map((btn, idx) =>
                            <button className="v2_nav_menu_cta_btn" key={idx} onClick={() => this.navigate(btn.route)}>
                                {btn.title[lang]} &rarr;
                            </button>
                        )}
                    </div>
                </div>
            </Fade>
          </>
        )
  }
}


export default NavbarMenu;
